import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend
} from "recharts";

function DarkTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div
      style={{
        background: "rgba(5,12,24,0.96)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 12,
        padding: "10px 12px",
        color: "#fff",
        boxShadow: "0 12px 30px rgba(0,0,0,0.35)",
      }}
    >
      <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 6 }}>{label}</div>
      {payload.map((entry, idx) => (
        <div key={idx} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, marginTop: 3 }}>
          <span style={{ width: 8, height: 8, borderRadius: 999, background: entry.color, display: "inline-block" }} />
          <span style={{ opacity: 0.82 }}>{entry.name}</span>
          <span style={{ fontWeight: 800 }}>{entry.value}</span>
        </div>
      ))}
    </div>
  );
}

export default function OperationalFlowChart({ data = [], title = "Operational Flow", subtitle = "", highlights = [] }) {
  return (
    <div
      style={{
        background: "linear-gradient(180deg, rgba(10,24,54,0.96), rgba(5,14,33,0.96))",
        border: "1px solid rgba(255,255,255,0.06)",
        borderRadius: 18,
        padding: 16,
        minHeight: 340,
      }}
    >
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 17, fontWeight: 900, color: "#fff" }}>{title}</div>
        {subtitle ? <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>{subtitle}</div> : null}
      </div>

      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={data} margin={{ top: 12, right: 8, bottom: 0, left: -18 }}>
          <CartesianGrid stroke="rgba(148,163,184,0.10)" vertical={false} />
          <XAxis dataKey="label" stroke="#9fb2ce" tickLine={false} axisLine={false} />
          <YAxis stroke="#9fb2ce" tickLine={false} axisLine={false} allowDecimals={false} />
          <Tooltip content={<DarkTooltip />} />
          <Legend />
          <Bar dataKey="clockins" name="clockins" fill="#47d7f4" radius={[6, 6, 0, 0]} />
          <Bar dataKey="submissions" name="submissions" fill="#22c55e" radius={[6, 6, 0, 0]} />
          <Bar dataKey="exceptions" name="exceptions" fill="#f59e0b" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>

      {highlights.length ? (
        <div style={{ marginTop: 10, display: "grid", gap: 8 }}>
          {highlights.map((text, idx) => (
            <div
              key={idx}
              style={{
                fontSize: 12,
                padding: "8px 10px",
                borderRadius: 12,
                background: "rgba(255,255,255,0.04)",
                color: "#d8e4ff",
              }}
            >
              {text}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
